<template>
<div>
  <b-container v-if="widgfinishvis" class="formback">
    <b-row align-h="center">
      <b-col cols="12" class="box">
        <b-row align-h="center" class="mt-4">
          <b-col cols="10">
            <h2>
              <span class="awesome">Thank you!<br /></span><span style="color:grey;" class="descriptionText">We sent you login details, please upload 3 documents (Approvals take ~5 min.)</span>
            </h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>

    </b-row>
  </b-container>

</div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'WidgFinish',
  data() {
    return {
      widgfinishvis: true,
    }
  },
  methods: {

    closeallwidg() {
      if ('parentIFrame' in window)
      window.parentIFrame.close();
      return false;

    }

  }
}

</script>

<style scoped>
.formback {
  background-color: white;
}

.element-margin {
  text-align: center;
}

.container {
  width: 340px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
}

.box {
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 2rem;
}

.frmField {
  background-color: white;
  color: #495057;
  line-height: 1.25;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  border: 0;
  padding: 10px;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  width: 90%;
}

.Password_field {
  margin-top: 1rem;
}

select,
input {
  max-width: 400px;
  margin: 1rem auto 0 auto;
}

#retype_password {
  margin: 0 auto 0 auto;
}

select:focus,
input:focus {
  box-shadow: none;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 1rem;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  color: #7b7e7d;
}

.awesome {
  color: #40c991;
}

.descriptionText{
  font-size: 1.5rem;

}


.element-margin {
  text-align: center;
}

.element-center {
  margin: 0 auto;
}


.box .separator .line {
  width: 1px;
  height: 40%;
  background-color: #a803a8;
}

.box .separator .or {
  width: fit-content;
  height: 10%;
  display: flex;
  align-items: center;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 3rem;
  color: #fff;
}

.input-icon {
  position: relative;
}

.input-icon>i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
  font-style: normal;
}

.input-icon>input {
  padding-left: 25px;
  padding-right: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

  {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/widgfinish.vue